var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome",style:({ backgroundImage: _vm.cImage() }),attrs:{"height":"100%"}},[(!_vm.loggedIn)?_c('Login',{attrs:{"id":"login"}}):_vm._e(),(_vm.loggedIn && _vm.changePWDialog)?_c('ChangePassword'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }